module.exports = __webpack_public_path__ + "media/images/Rectangle 1380-9e5062aff81535e53b62e063faf7d32c.svg";